module.exports = __webpack_public_path__ + "img/profile-laptop.4469f56b.jpeg";